module.exports = __webpack_public_path__ + "fonts/48a6761c/proximanova-light-webfont.woff";